import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import * as _ from 'lodash';
import { bindActionCreators } from 'redux';
import * as accountActions from '../../../actions/accountActions';
import LanguageSelector from './LanguageSelector';
import * as revealActions from '../../../actions/revealActions';
import UserPasswordRecoverReveal, { RECOVER_USER_PASSWORD_REVEAL } from './reveal/UserPasswordRecoverReveal';
import { SmartButton } from '../../common/SmartButton';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { Button, Paragraph, Input } from '@netexknowledge/smart-components';
import { isGoogleConnected, requestPermissions, revokeGoogleConnection } from '../../../utils/google/googleUtils';
import { NETEX_INFRA } from '../../../config_module';
import { MAX_LENGTH_VARIABLES, GOOGLE_USERINFO_SCOPES, ROLE } from '../../../const';
import Switch from '@material-ui/core/Switch';
import { getConfigurationFromStorage } from '../../../shared';
import { getUserConfiguration } from '../../../services/api/userApi';

export class ProfileForm extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.setNewLanguage = this.setNewLanguage.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeSurname = this.handleChangeSurname.bind(this);
    this.setNewUserValue = this.setNewUserValue.bind(this);
    this.updateUserData = this.updateUserData.bind(this);
    this.checkGoogleConnection = this.checkGoogleConnection.bind(this);

    this.state = {
      enableGenAI: false,
      enableNeaeAdaptations: false,
      notificationsEnabled: false,
      userConfiguration: null,
      nameErrors: '',
      surnameErrors: '',
      emailErrors: ''
    };
  }

  static propTypes = {
    user: PropTypes.object,
    newUserData: PropTypes.object,
    colors: PropTypes.object,
    studentProfile: PropTypes.any,
    accountActions: PropTypes.any,
    classroomActions: PropTypes.any,
    revealActions: PropTypes.any,
    allowShareInGoogleClassroom: PropTypes.bool,
    googleMeetClientId: PropTypes.string
  };

  state = {
    isGoogleConnected: false
  };

  componentWillUnmount = () => {
    this.props.classroomActions.setSelectedStudentProfile(undefined);
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.studentProfile !== this.props.studentProfile) {
      this.updateUserData();
    }
  }

  componentDidMount() {
    this.checkGoogleConnection();
    this.updateUserData();
    getUserConfiguration(this.props.user._id).then(configuration => {
      const { userId, ...userConfigurationWithoutUserId } = configuration;
      this.setState({
        enableGenAI: configuration.enableGenAI,
        enableNeaeAdaptations: configuration.enableNeaeAdaptations,
        notificationsEnabled: configuration.activateNotifications,
        userConfiguration: userConfigurationWithoutUserId
      });
    });
  }

  checkGoogleConnection() {
    isGoogleConnected().then(isConnected => {
      this.setState({ isGoogleConnected: isConnected });
    });
  }

  updateUserData() {
    const { accountActions, studentProfile, user } = this.props;
    if (_.isNil(studentProfile)) {
      accountActions.setNewUserData(user);
    } else {
      accountActions.setNewUserData(studentProfile);
    }
  }

  validateForm(input, value) {
    const errors = { ...this.state };

    const setError = (field, errorMessage) => {
      errors[field] = errorMessage;
    };

    const validateField = (field, maxLength, fieldName) => {
      if (value.length > maxLength) {
        setError(
          `${field}Errors`,
          I18n.t('error.valueLength', { variable: I18n.t(`userProfile.form.${fieldName}`), length: maxLength })
        );
      } else if (value.length === 0) {
        setError(`${field}Errors`, I18n.t('error.valueRequired'));
      } else {
        setError(`${field}Errors`, '');
      }
    };

    const validateEmail = email => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email) && email.length <= MAX_LENGTH_VARIABLES.EMAIL) {
        setError(`emailErrors`, I18n.t('error.invalidEmail'));
      } else {
        setError(`emailErrors`, '');
      }
    };

    switch (input) {
      case 'name':
        validateField('name', MAX_LENGTH_VARIABLES.NAME, 'name');
        break;
      case 'surname':
        validateField('surname', MAX_LENGTH_VARIABLES.SURNAME, 'surname');
        break;
      case 'email':
        validateField('email', MAX_LENGTH_VARIABLES.EMAIL, 'email');
        validateEmail(value);
        break;
      default:
        break;
    }

    this.setState(errors);
  }

  setNewUserValue(attr, value) {
    const { accountActions, newUserData } = this.props;
    let newUser = _.cloneDeep(newUserData);

    newUser[attr] = value;
    accountActions.setNewUserData(newUser);
  }

  handleChangePassword() {
    this.props.revealActions.setOpenReveal(RECOVER_USER_PASSWORD_REVEAL);
  }

  handleChangeName(ev) {
    this.setNewUserValue('name', ev.target.value);
    this.validateForm('name', ev.target.value);
  }

  handleChangeSurname(ev) {
    this.setNewUserValue('surname', ev.target.value);
    this.validateForm('surname', ev.target.value);
  }

  handleChangeEmail(ev) {
    this.setNewUserValue('email', ev.target.value);
    this.validateForm('email', ev.target.value);
  }

  setNewLanguage(language) {
    if (language) {
      this.setNewUserValue('language', language);
    }
  }

  renderNameRow() {
    const { newUserData, studentProfile, disableModifyUiProfileOptions } = this.props;
    const { nameErrors, surnameErrors } = this.state;

    return (
      <div className="name-row">
        <div className="name">
          <div className="input-title">{I18n.t('userProfile.form.name')}</div>
          <Input
            type="text"
            value={newUserData.name ? newUserData.name : ''}
            onChange={this.handleChangeName}
            disabled={studentProfile ? true : disableModifyUiProfileOptions ? true : false}
            state={nameErrors ? 'error' : ''}
            helper={nameErrors}
          />
        </div>
        <div className="surname">
          <div className="input-title">{I18n.t('userProfile.form.surname')}</div>
          <Input
            type="text"
            value={newUserData.surname ? newUserData.surname : ''}
            onChange={this.handleChangeSurname}
            disabled={studentProfile ? true : disableModifyUiProfileOptions ? true : false}
            state={surnameErrors ? 'error' : ''}
            helper={surnameErrors}
          />
        </div>
      </div>
    );
  }

  renderEmail() {
    const { newUserData, studentProfile, user, disableStudentProfileEmailChange } = this.props;
    const { emailErrors } = this.state;
    const emailDisabled =
      Boolean(studentProfile) ||
      (user && user.role === ROLE.STUDENT && disableStudentProfileEmailChange);

    return (
      <div id="profile-form-email">
        <div className="input-title">{I18n.t('userProfile.form.email')}</div>
        <Input
          type="email"
          value={newUserData.email ? newUserData.email : ''}
          onChange={this.handleChangeEmail}
          disabled={emailDisabled}
          state={emailErrors ? 'error' : ''}
          helper={emailErrors}
        />
      </div>
    );
  }

  handleNotificationsSwitchChange() {
    const { userConfiguration, notificationsEnabled } = this.state;
    const newNotificationsEnabled = !notificationsEnabled;
    const updatedUserConfiguration = {
      ...userConfiguration,
      activateNotifications: newNotificationsEnabled
    };
    this.setNewUserValue('userConfiguration', updatedUserConfiguration);
    this.setState({
      notificationsEnabled: newNotificationsEnabled,
      userConfiguration: updatedUserConfiguration
    });
  }

  handleGenAISwitchChange() {
    const { userConfiguration, enableGenAI } = this.state;
    const newEnableGenAI = !enableGenAI;
    const updatedUserConfiguration = {
      ...userConfiguration,
      enableGenAI: newEnableGenAI
    };
    this.setNewUserValue('userConfiguration', updatedUserConfiguration);
    this.setState({
      enableGenAI: newEnableGenAI,
      userConfiguration: updatedUserConfiguration
    });
  }

  renderNotificationsSwitch() {
    const { user, studentProfile, disableModifyUiProfileOptions } = this.props;
    const { notificationsEnabled } = this.state;
    const costumerConfiguration = getConfigurationFromStorage() ? JSON.parse(getConfigurationFromStorage()) : null;
    if (!costumerConfiguration.activateNotifications || (user && studentProfile && user._id !== studentProfile._id)) {
      return;
    }
    return (
      <div className="switch-container">
        <Switch
          data-cy=""
          color="primary"
          checked={notificationsEnabled}
          disabled={studentProfile || disableModifyUiProfileOptions}
          onClick={() => this.handleNotificationsSwitchChange()}
        />

        {I18n.t('userProfile.activeNotifications')}
      </div>
    );
  }

  renderGenAISwitch() {
    const { user, studentProfile } = this.props;
    const { enableGenAI } = this.state;
    const costumerConfiguration = getConfigurationFromStorage() ? JSON.parse(getConfigurationFromStorage()) : null;

    if (
      !costumerConfiguration.enableGenAI ||
      user.role === ROLE.STUDENT ||
      (user && studentProfile && user._id !== studentProfile._id)
    ) {
      return;
    }

    return (
      <div className="switch-container">
        <Switch data-cy="" color="primary" checked={enableGenAI} onClick={() => this.handleGenAISwitchChange()} />

        {I18n.t('userProfile.enableGenAI')}
      </div>
    );
  }

  handleNeaeAdaptationsSwitchChange() {
    const { userConfiguration, enableNeaeAdaptations } = this.state;
    const newEnableNeaeAdaptations = !enableNeaeAdaptations;
    const updatedUserConfiguration = {
      ...userConfiguration,
      enableNeaeAdaptations: newEnableNeaeAdaptations
    };
    this.setNewUserValue('userConfiguration', updatedUserConfiguration);
    this.setState({
      enableNeaeAdaptations: newEnableNeaeAdaptations,
      userConfiguration: updatedUserConfiguration
    });
  }

  renderNeaeAdaptationsSwitch() {
    const { user, studentProfile } = this.props;
    const { enableNeaeAdaptations } = this.state;
    const costumerConfiguration = getConfigurationFromStorage() ? JSON.parse(getConfigurationFromStorage()) : null;

    if (
      !costumerConfiguration.enableNeaeAdaptations ||
      user.role === ROLE.STUDENT ||
      (user && studentProfile && user._id !== studentProfile._id)
    ) {
      return;
    }

    return (
      <div className="switch-container">
        <Switch
          data-cy=""
          color="primary"
          checked={enableNeaeAdaptations}
          onClick={() => this.handleNeaeAdaptationsSwitchChange()}
        />

        {I18n.t('userProfile.neaeAdaptationsButton')}
      </div>
    );
  }

  renderRecoverPassword() {
    const { disableModifyUiProfileOptions } = this.props;

    return (
      <SmartButton
        id="profile-form-recover-password-button"
        success
        disabled={disableModifyUiProfileOptions ? true : false}
        onClick={this.handleChangePassword}
      >
        {I18n.t('userProfile.passwordRecover')}
      </SmartButton>
    );
  }

  renderRemoveUserAndRecoverPassword() {
    const { studentProfile } = this.props;

    return (
      <div className="button-field" style={{ marginBottom: '64px' }}>
        {!studentProfile && this.renderRecoverPassword()}
      </div>
    );
  }

  renderLanguage() {
    const { newUserData, studentProfile } = this.props;

    return (
      <div className="language-selector">
        <div className="input-title">{I18n.t('userProfile.form.language')}</div>
        <LanguageSelector
          disabled={studentProfile ? true : false}
          selected={newUserData.language}
          updateLanguage={this.setNewLanguage}
        />
      </div>
    );
  }

  renderIntegrations() {
    const onClickConnectGoogle = () => {
      if (this.state.isGoogleConnected) {
        revokeGoogleConnection().then(() => {
          this.checkGoogleConnection();
        });
      } else {
        requestPermissions(GOOGLE_USERINFO_SCOPES, () => {
          this.checkGoogleConnection();
        }).then();
      }
    };

    return (
      <div className="user-profile-form-integrations">
        <Paragraph type="h4" children={I18n.t('common.integrations')} />
        <div className="integrations">
          {NETEX_INFRA && (
            <Button
              primary={!this.state.isGoogleConnected}
              label={
                this.state.isGoogleConnected
                  ? `${I18n.t('common.disconnect')} Google`
                  : `${I18n.t('common.connect')} Google`
              }
              onClick={() => onClickConnectGoogle()}
            />
          )}
        </div>
      </div>
    );
  }

  render() {
    const { newUserData, user, allowShareInGoogleClassroom, googleMeetClientId } = this.props;
    const isSameUser = newUserData._id === user._id;
    const isGoogleNeeded = allowShareInGoogleClassroom || googleMeetClientId !== '';

    return (
      <div className="user-profile-form">
        <UserPasswordRecoverReveal user={newUserData} />
        {this.renderNameRow()}
        {this.renderEmail()}
        {this.renderLanguage()}
        {this.renderRemoveUserAndRecoverPassword()}
        {this.renderNotificationsSwitch()}
        {this.renderGenAISwitch()}
        {this.renderNeaeAdaptationsSwitch()}
        {isGoogleNeeded && isSameUser && this.renderIntegrations()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.account.user,
    newUserData: state.account.newUserData,
    colors: state.theme.colors,
    studentProfile: state.student.selectedStudent,
    allowShareInGoogleClassroom: state.account.configuration.allowShareInGoogleClassroom,
    googleMeetClientId: state.account.configuration.meetClientId,
    disableModifyUiProfileOptions: state.account.configuration.disableModifyUiProfileOptions,
    disableStudentProfileEmailChange: state.account.configuration.disableStudentProfileEmailChange
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    revealActions: bindActionCreators(revealActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);
